/*
Important:
This Component is used only for the Vue3 application
Any modifications made should be done for Vue2 component also
Vue2File: wwwroot\js\services\UniteDigital\UniteDigital.js
Dont forget to make the changes in both the files
Any clarifications contact Leela
*/

import { ExpressPayments } from '../../Services/Payments/ExpressPayments';

export default class UniteDigital {
  formObject = {
    token: window.vendorToken,
    vendor: 'Team Velocity',
  };
  vehicleDetails = '';

  sendOrbWithVehicle(obj, label) {
    if (window.vin) {
      ExpressPayments.vehicleDetails(window.vin).then((response) => {
        this.vehicleDetails = {
          vin: window.vin,
          year: response.data.year,
          make: response.data.make,
          model: response.data.model,
        };

        obj.vehicle = this.vehicleDetails;
        orb('track', label, obj);
      });
    } else {
      orb('track', label, obj);
    }
  }

  view(label, objectName, actionName, data, category) {
    let obj = {
      action: actionName,
      object: objectName,
      ...this.formObject,
    };

    if (category) {
      obj = { ...obj, ...category };
    }

    if (data) {
      obj = { ...obj, ...data };
    }
    this.sendOrbWithVehicle(obj, label);
  }

  openForm(label, objectName) {
    let obj = {
      action: 'open',
      object: objectName,
      ...this.formObject,
    };

    this.sendOrbWithVehicle(obj, label);
  }

  startForm(label, objectName) {
    let obj = {
      action: 'start',
      object: objectName,
      ...this.formObject,
    };
    this.sendOrbWithVehicle(obj, label);
  }

  submitForm(label, contactDetails, objectName, logLeadId = '') {
    let obj = {
      action: 'submit',
      object: objectName,
      ...this.formObject,
    };

    if (contactDetails) {
      obj.lead = contactDetails;
    }
    this.sendOrbWithVehicle(obj, label);
  }
}
